import { useRef } from 'react';
import { Form, Input } from 'antd-mobile';

/**
 * 输入框模板
 * @param {
 *  item:对应的表单模板
 *  setFormInfo:向传给接口的对象中新增对应表单数据
 * } props 
 * @returns 
 */
export function BpmFormInput(props) {
  const { postName, label, message, disabled, required } = props.item
  const { setFormInfo } = props
  const inputRef = useRef(null)
  /** 自定义自定义校验 */
  const validate = {
    rules: [
      {
        required: required,
        message: '',
      },
      {
        validator: (_, value) => {
          if (required && !value) {
            return Promise.reject(new Error(`请输入${label}`))
          }
          if (required && label === '手机号码' && !(/^1[3456789]\d{9}$/.test(value))) {
            return Promise.reject('请输入正确的手机号码')
          }
          if (required && label === '证件号码') {
            // 如果value包含*号则不验证
            if (value.length === 18 && value.indexOf('*') !== -1) {
              return Promise.resolve()
            }
            if (!(/(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(value))) {
              return Promise.reject('请输入正确的身份证号码')
            }
          }
          // 如果label为包含'邮箱'的字符串,则校验邮箱格式
          if (value && label.includes('邮箱') && !(/^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/).test(value)) {
            return Promise.reject('请输入正确的邮箱')
          }

          return Promise.resolve()
        }
      }
    ]
  }
  /** 自定义触发验证时机 */
  const trigger = {
    validateTrigger: 'onBlur'
  }

  return (
    <Form.Item
      name={postName}
      label={label}
      rules={validate.rules}
      {...trigger}
    >
      <Input
        ref={inputRef}
        disabled={disabled}
        onChange={value => setFormInfo(postName, value)}
        placeholder={message}
        className='inputTextAlign'
      />
    </Form.Item>
  )
}